module.exports = {"330784001":"东城街道","330784002":"西城街道","330784003":"江南街道","330784105":"石柱镇","330784106":"前仓镇","330784107":"舟山镇","330784108":"古山镇","330784109":"方岩镇","330784110":"龙山镇","330784111":"西溪镇","330784112":"象珠镇","330784113":"唐先镇","330784114":"花街镇","330784115":"芝英镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330784.json
// module id = 1005
// module chunks = 0